/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import { aggregateAxios } from './../../util/Api';
import {
  SHOW_ERROR_MESSAGE,
  FETCH_GENERAL_TOTAL_START,
  FETCH_GENERAL_TOTAL_SUCCESS,
  FETCH_GENERAL_TOTAL_ERROR,
  FETCH_GENERAL_TOTAL_CUMULATIVE_START,
  FETCH_GENERAL_TOTAL_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_CUMULATIVE_ERROR,
  FETCH_GENERAL_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_TOTAL_HOURLY_SUCCESS,
  FETCH_GENERAL_USD_TOTAL_HOURLY_SUCCESS,
  FETCH_GENERAL_EUR_TOTAL_HOURLY_SUCCESS,
  FETCH_GENERAL_TOTAL_MONTH_SUCCESS,
  FETCH_GENERAL_EUR_TOTAL_DAILY_SUCCESS,
  FETCH_GENERAL_USD_TOTAL_DAILY_SUCCESS,
  FETCH_GENERAL_TOTAL_THIS_MONTH_SUCCESS,
  FETCH_GENERAL_TOTAL_LAST_MONTH_SUCCESS,
  FETCH_GENERAL_TOTAL_DAILY_LAST_MONTH_SUCCESS,
  FETCH_GENERAL_TOTAL_DAILY_THIS_MONTH_SUCCESS,
  FETCH_GENERAL_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_GENERAL_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_START,
  FETCH_MERCHANT_TOTAL_SUCCESS,
  FETCH_MERCHANT_TOTAL_ERROR,
  FETCH_MERCHANT_TOTAL_CUMULATIVE_START,
  FETCH_MERCHANT_TOTAL_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_CUMULATIVE_ERROR,
  FETCH_MERCHANT_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_TOTAL_HOURLY_SUCCESS,
  FETCH_MERCHANT_USD_TOTAL_HOURLY_SUCCESS,
  FETCH_MERCHANT_EUR_TOTAL_HOURLY_SUCCESS,
  FETCH_MERCHANT_TOTAL_MONTH_SUCCESS,
  FETCH_MERCHANT_EUR_TOTAL_DAILY_SUCCESS,
  FETCH_MERCHANT_USD_TOTAL_DAILY_SUCCESS,
  FETCH_MERCHANT_TOTAL_THIS_MONTH_SUCCESS,
  FETCH_MERCHANT_TOTAL_LAST_MONTH_SUCCESS,
  FETCH_MERCHANT_TOTAL_DAILY_LAST_MONTH_SUCCESS,
  FETCH_MERCHANT_TOTAL_DAILY_THIS_MONTH_SUCCESS,
  FETCH_MERCHANT_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS,
  FETCH_MERCHANT_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS
} from '../../constants/ActionTypes';

export const fetchGeneralTotal = (payment_method, currency, transaction_status, interval, period = "None", params = '') => (dispatch) => {
  dispatch({ type: FETCH_GENERAL_TOTAL_START });
  let url = "totals/general/collections";
  let parameters = params;

  if (payment_method) {
    url += `/${payment_method}`;
  }

  if (currency && currency !== 'ALL') {
    parameters += `&currency=${currency}`;
  }
  if (transaction_status) {
    url += `/${transaction_status}`;
  }
  if (interval) {
    url += `/${interval}`;
  }
  if (params) {
    url += `?${parameters}`;
  }

  aggregateAxios
    .get(url)
    .then((axiosResponse) => {
      const response = axiosResponse?.data;
      const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
      const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
      const data = {
        data: response.data, currentPage, totalItems,
      };
      switch (interval) {
        case 'hour':
          switch (currency) {
            case 'USD':
              dispatch({ type: FETCH_GENERAL_USD_TOTAL_HOURLY_SUCCESS, payload: data });
              break;
            case 'EUR':
              dispatch({ type: FETCH_GENERAL_EUR_TOTAL_HOURLY_SUCCESS, payload: data });
              break;
            default:
              dispatch({ type: FETCH_GENERAL_TOTAL_HOURLY_SUCCESS, payload: data });
              break;
          }
        case 'daily':
          switch (currency) {
            case 'USD':
              dispatch({ type: FETCH_GENERAL_USD_TOTAL_DAILY_SUCCESS, payload: data });
              break;
            case 'EUR':
              dispatch({ type: FETCH_GENERAL_EUR_TOTAL_DAILY_SUCCESS, payload: data });
              break;
          }
          switch (period) {
            case 'this_month':
              dispatch({ type: FETCH_GENERAL_TOTAL_DAILY_THIS_MONTH_SUCCESS, payload: data });
              break;
            case 'last_month':
              dispatch({ type: FETCH_GENERAL_TOTAL_DAILY_LAST_MONTH_SUCCESS, payload: data });
              break;
          }
          break;
        case 'month':
          switch (period) {
            case 'this_month':
              dispatch({ type: FETCH_GENERAL_TOTAL_THIS_MONTH_SUCCESS, payload: data });
              break;
            case 'last_month':
              dispatch({ type: FETCH_GENERAL_TOTAL_LAST_MONTH_SUCCESS, payload: data });
              break;
            default:
              dispatch({ type: FETCH_GENERAL_TOTAL_MONTH_SUCCESS, payload: data });
              break;
          }
          break;
        default:
          dispatch({ type: FETCH_GENERAL_TOTAL_SUCCESS, payload: data });
          break;
      }
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
      }
      dispatch({ type: FETCH_GENERAL_TOTAL_ERROR });
    });
};


export const fetchGeneralTotalCumulative = (payment_method, currency, transaction_status, interval, period = "None", params = '') => (dispatch) => {
  dispatch({ type: FETCH_GENERAL_TOTAL_CUMULATIVE_START });
  let url = "totals/general/collections";
  let parameters = params;

  if (payment_method) {
    url += `/${payment_method}`;
  }

  if (currency && currency !== 'ALL') {
    parameters += `&currency=${currency}`;
  }
  if (transaction_status) {
    url += `/${transaction_status}`;
  }
  if (interval) {
    url += `/${interval}`;
  }

  // make sure to add the cumulative endpoint
  url += '/total';

  if (params) {
    url += `?${parameters}`;
  }

  aggregateAxios
    .get(url)
    .then((axiosResponse) => {
      const response = axiosResponse?.data;
      const data = {
        data: response.data,
      };
      switch (period) {
        case 'today':
          switch (currency) {
            case 'USD':
              dispatch({ type: FETCH_GENERAL_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS, payload: data });
              break;
            case 'EUR':
              dispatch({ type: FETCH_GENERAL_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS, payload: data });
              break;
            default:
              dispatch({ type: FETCH_GENERAL_TOTAL_TODAY_CUMULATIVE_SUCCESS, payload: data });
              break;
          }
          break;
        case 'yesterday':
          switch (currency) {
            case 'USD':
              dispatch({ type: FETCH_GENERAL_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS, payload: data });
              break;
            case 'EUR':
              dispatch({ type: FETCH_GENERAL_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS, payload: data });
              break;
            default:
              dispatch({ type: FETCH_GENERAL_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS, payload: data });
              break;
          }
        case 'this_month':
          dispatch({ type: FETCH_GENERAL_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS, payload: data });
          break;
        case 'last_month':
          dispatch({ type: FETCH_GENERAL_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS, payload: data });
          break;
        default:
          dispatch({ type: FETCH_GENERAL_TOTAL_CUMULATIVE_SUCCESS, payload: data });
          break;
      }
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
      }
      dispatch({ type: FETCH_GENERAL_TOTAL_CUMULATIVE_ERROR });
    });
};


export const fetchMerchantTotal = (merchant_id, payment_method, currency, transaction_status, interval, period = "None", params = '') => (dispatch) => {
  dispatch({ type: FETCH_MERCHANT_TOTAL_START });
  let url = "totals/merchant/collections";
  let parameters = params

  if (merchant_id) {
    url += `/${merchant_id}`;
  }

  if (payment_method) {
    url += `/${payment_method}`;
  }

  if (currency && currency !== 'ALL') {
    parameters += `&currency=${currency}`;
  }
  if (transaction_status) {
    url += `/${transaction_status}`;
  }
  if (interval) {
    url += `/${interval}`;
  }
  if (params) {
    url += `?${parameters}`;
  }

  aggregateAxios
    .get(url)
    .then((axiosResponse) => {
      const response = axiosResponse?.data;
      const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
      const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
      const data = {
        data: response.data, currentPage, totalItems,
      };
      switch (interval) {
        case 'hour':
          switch (currency) {
            case 'USD':
              dispatch({ type: FETCH_MERCHANT_USD_TOTAL_HOURLY_SUCCESS, payload: data });
              break;
            case 'EUR':
              dispatch({ type: FETCH_MERCHANT_EUR_TOTAL_HOURLY_SUCCESS, payload: data });
              break;
            default:
              dispatch({ type: FETCH_MERCHANT_TOTAL_HOURLY_SUCCESS, payload: data });
              break;
          }
        case 'daily':
          switch (currency) {
            case 'USD':
              dispatch({ type: FETCH_MERCHANT_USD_TOTAL_DAILY_SUCCESS, payload: data });
              break;
            case 'EUR':
              dispatch({ type: FETCH_MERCHANT_EUR_TOTAL_DAILY_SUCCESS, payload: data });
              break;
          }
          switch (period) {
            case 'this_month':
              dispatch({ type: FETCH_MERCHANT_TOTAL_DAILY_THIS_MONTH_SUCCESS, payload: data });
              break;
            case 'last_month':
              dispatch({ type: FETCH_MERCHANT_TOTAL_DAILY_LAST_MONTH_SUCCESS, payload: data });
              break;
          }
          break;
        case 'month':
          switch (period) {
            case 'this_month':
              dispatch({ type: FETCH_MERCHANT_TOTAL_THIS_MONTH_SUCCESS, payload: data });
              break;
            case 'last_month':
              dispatch({ type: FETCH_MERCHANT_TOTAL_LAST_MONTH_SUCCESS, payload: data });
              break;
            default:
              dispatch({ type: FETCH_MERCHANT_TOTAL_MONTH_SUCCESS, payload: data });
              break;
          }
          break;
        default:
          dispatch({ type: FETCH_MERCHANT_TOTAL_SUCCESS, payload: data });
          break;
      }
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
      }
      dispatch({ type: FETCH_MERCHANT_TOTAL_ERROR });
    });
};


export const fetchMerchantTotalCumulative = (merchant_id, payment_method, currency, transaction_status, interval, period = "None", params = '') => (dispatch) => {
  dispatch({ type: FETCH_MERCHANT_TOTAL_CUMULATIVE_START });
  let url = "totals/merchant/collections";
  let parameters = params;

  if (merchant_id) {
    url += `/${merchant_id}`;
  }

  if (payment_method) {
    url += `/${payment_method}`;
  }

  if (currency && currency !== 'ALL') {
    parameters += `&currency=${currency}`;
  }
  if (transaction_status) {
    url += `/${transaction_status}`;
  }
  if (interval) {
    url += `/${interval}`;
  }

  // make sure to add the cumulative endpoint
  url += '/total';

  if (params) {
    url += `?${parameters}`;
  }

  aggregateAxios
    .get(url)
    .then((axiosResponse) => {
      const response = axiosResponse?.data;
      const data = {
        data: response.data,
      };
      switch (period) {
        case 'today':
          switch (currency) {
            case 'USD':
              dispatch({ type: FETCH_MERCHANT_USD_TOTAL_TODAY_CUMULATIVE_SUCCESS, payload: data });
              break;
            case 'EUR':
              dispatch({ type: FETCH_MERCHANT_EUR_TOTAL_TODAY_CUMULATIVE_SUCCESS, payload: data });
              break;
            default:
              dispatch({ type: FETCH_MERCHANT_TOTAL_TODAY_CUMULATIVE_SUCCESS, payload: data });
              break;
          }
          break;
        case 'yesterday':
          switch (currency) {
            case 'USD':
              dispatch({ type: FETCH_MERCHANT_USD_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS, payload: data });
              break;
            case 'EUR':
              dispatch({ type: FETCH_MERCHANT_EUR_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS, payload: data });
              break;
            default:
              dispatch({ type: FETCH_MERCHANT_TOTAL_YESTERDAY_CUMULATIVE_SUCCESS, payload: data });
              break;
          }
        case 'this_month':
          dispatch({ type: FETCH_MERCHANT_TOTAL_THIS_MONTH_CUMULATIVE_SUCCESS, payload: data });
          break;
        case 'last_month':
          dispatch({ type: FETCH_MERCHANT_TOTAL_LAST_MONTH_CUMULATIVE_SUCCESS, payload: data });
          break;
        default:
          dispatch({ type: FETCH_MERCHANT_TOTAL_CUMULATIVE_SUCCESS, payload: data });
          break;
      }
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
      }
      dispatch({ type: FETCH_MERCHANT_TOTAL_CUMULATIVE_ERROR });
    });
};

